import {session} from "./session";
import {AjaxUtil} from "../utils/ajax-util";

type AccessAuthorization = {
    CanCreate: boolean,
    CanDelete: boolean,
    CanRead: boolean,
    CanUpdate: boolean,
    Name: string,
}

type DFFeature = {
    AllowNonSecureEmployeeData: boolean,
    AllowNonSecureLocationPositionData: boolean,
    Description: string | null,
    DisplayName: string,
    EnableOrgChangeEvent: boolean,
    FavoriteFeatureSequence: null
    FeatureId: number,
    FeatureTechTypeCode: string | null
    FeatureTypeCode: string | null; // HTML
    IsAsyncReport: boolean,
    ParentFeatureId: number | null
    RoleSequence: number,
    ShowInFeatureToolbar: boolean,
    ShowOrgPicker: boolean,
    SubFeatures: DFFeature[] | [],
    TargetObjectType: string,
    Url: string,
}

export type UserFeaturesType = {
    AccessAuthorizations: AccessAuthorization[],
    Features: {
        UserFeatures: DFFeature[],
    },
};

export type routeType = {
    name: string,
    path: string | null,
    exact: boolean,
    Component?: any,
    access?: 'logged-in' | 'logged-out',
    featureId?: number,
    featureTypeCode?: string,
    featureTechTypeCode?: string,
    targetObjectType? :string,
    children?: routeType[] | 0,
}

function extracted(Feature: DFFeature[]):routeType[] {
    return Feature.map((item): routeType => ({
        name: item.DisplayName,
        path: item.Url,
        exact: true,
        access: 'logged-in',
        featureId: item.FeatureId,
        featureTypeCode: item.FeatureTypeCode,
        featureTechTypeCode: item.FeatureTechTypeCode,
        targetObjectType: item.TargetObjectType,
        children: item.SubFeatures.length && extracted(item.SubFeatures),
    }));
}

export const getRoutes = async (): Promise<routeType[]> => {
    const path = 'Framework/Main/GetFeaturesAndAuthorizations';
    const data = {useCache: false};
    try {
        const res: UserFeaturesType = await session.postRequest(AjaxUtil.addClientBrowserId(path), data);
        console.log('getRoutes', {res});
        return extracted(res.Features.UserFeatures);
    } catch (err) {
        throw err;
    }
}